import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { Member } from '../../@types/member'
import { Prefix } from '../../@types/prefix'
import { makePath } from '../../helpers/path'
import TopbarWidget from './TopbarWidget'
import { Avatar, Typography } from 'antd';
import { topbarText } from '../../constant'

const { Text } = Typography
interface TopbarProps {
	prefix?: Prefix
	member?: Member
	pathname: string
}
const Topbar: FC<TopbarProps> = ({ prefix, member, pathname }) => {
	return (
		<>
			<div className='topbar'>
				{/* {(pathname === '/wallet' || pathname === '/launch-game') && ( */}
				<div className="topbar-logo">
					<Link to={makePath('/wallet')}>
						{prefix?.logo ? (
							<Avatar
								className="avatar-logo avatar-logo-topbar"
								src={prefix?.logo}
								shape="square"
							/>
						) : (
							<div className="prefix-name">{prefix?.prefix}</div>
						)}
					</Link>
				</div>
				{/* )} */}

				<div className="topbar-title">
					<Text>
						{topbarText[pathname] ?? ''}
					</Text>
				</div>
				<TopbarWidget prefix={prefix} member={member} />
			</div>
		</>
	)
}

export default Topbar
